import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconModule } from '@shared/core/components/icon';

import { ClearCartBtnComponent } from './cart-clear-btn.shared.component';

@NgModule({
    declarations: [
        ClearCartBtnComponent
    ],
    imports: [
        CommonModule,
        IconModule
    ],
    exports: [
        ClearCartBtnComponent
    ],
    providers: [],
})
export class ClearCartBtnModule { }
